import { Quiz } from '@/types/quiz';

export const quizAll: Quiz[] = [
  {
    quizId: '1',
    question: '高校入学にあたり一人暮らしを始めた筒井雪隆の部屋番号は？',
    options: [
      { optionId: '0', text: '502号室' },
      { optionId: '1', text: '501号室' },
      { optionId: '2', text: '503号室' },
      { optionId: '3', text: '504号室' },
      { optionId: '4', text: '505号室' },
    ],
  },
  {
    quizId: '2',
    question: '王子と筒井雪隆の初めての邂逅、王子の第一声は？',
    options: [
      { optionId: '0', text: '君…誰？' },
      { optionId: '1', text: 'やぁ こんにちは' },
      { optionId: '2', text: 'はじめまして' },
      { optionId: '3', text: 'やぁ 雪隆' },
      { optionId: '4', text: '部屋借りてるよ' },
    ],
  },
  {
    quizId: '3',
    question:
      'バカ王子・地球襲来編より問題です。\n筒井雪隆が入居数前に王子は筒井雪隆の部屋へどうやって入った？',
    options: [
      { optionId: '0', text: 'ガラスを割り窓の鍵を解錠した' },
      { optionId: '1', text: 'ピッキングで扉の鍵を解錠した' },
      { optionId: '2', text: '合鍵で扉の鍵を解錠した' },
      { optionId: '3', text: 'ドグラ星の道具で壁をすり抜けた' },
      { optionId: '4', text: '施錠されていない窓から侵入した' },
    ],
  },
  {
    quizId: '4',
    question:
      'ザ・ワイドで地元民が撮影したビデオをみて、落ちてきた物体はUFOだと断言していたのは？',
    options: [
      { optionId: '0', text: 'たま出版の韮沢' },
      { optionId: '1', text: '草野仁' },
      { optionId: '2', text: '矢追純一' },
      { optionId: '3', text: '高坂勝巳' },
      { optionId: '4', text: '志水一夫' },
    ],
  },
  {
    quizId: '5',
    question: '江戸川美歩の父親の名前は？',
    options: [
      { optionId: '0', text: '江戸川蘭蔵' },
      { optionId: '1', text: '江戸川新歩' },
      { optionId: '2', text: '江戸川小五郎' },
      { optionId: '3', text: '江戸川信二' },
      { optionId: '4', text: '江戸川吾南' },
    ],
  },
  {
    quizId: '6',
    question:
      'バカ王子・地球襲来編より問題です。\n王子が5階から飛び降りた時の擬音は？',
    options: [
      { optionId: '0', text: 'トーン' },
      { optionId: '1', text: 'ギューン' },
      { optionId: '2', text: 'バーン' },
      { optionId: '3', text: 'フッ' },
      { optionId: '4', text: 'スーッ' },
    ],
  },
  {
    quizId: '7',
    question: '王子の血は何色？',
    options: [
      { optionId: '0', text: '青色' },
      { optionId: '1', text: '赤色' },
      { optionId: '2', text: '緑色' },
      { optionId: '3', text: '橙色' },
      { optionId: '4', text: '紫色' },
    ],
  },
  {
    quizId: '8',
    question: '筒井雪隆は毎日何kmのジョギングをしている？',
    options: [
      { optionId: '0', text: '5km' },
      { optionId: '1', text: '1km' },
      { optionId: '2', text: '2km' },
      { optionId: '3', text: '10km' },
      { optionId: '4', text: '15km' },
    ],
  },
  {
    quizId: '9',
    question: '江戸川蘭蔵が後ろめたいことがあることを話すときの特徴は？',
    options: [
      { optionId: '0', text: '気難しそうに、人の目を見据えて話す' },
      { optionId: '1', text: '面倒臭そうに話す' },
      { optionId: '2', text: '視線を左右へせわしなく動かしながら話す' },
      { optionId: '3', text: 'まばたきをせずに、ゆっくりと話す' },
      { optionId: '4', text: '表情柔らかく、落ち着いて話す' },
    ],
  },
  {
    quizId: '10',
    question: '多様な擬態能力を持つクライブ、どこの星の生物？',
    options: [
      { optionId: '0', text: 'ジャクリンS星' },
      { optionId: '1', text: 'ペギ星' },
      { optionId: '2', text: '惑星カルバリ' },
      { optionId: '3', text: 'エラル星' },
      { optionId: '4', text: '惑星ホルン' },
    ],
  },
  {
    quizId: '11',
    question: '江戸川美歩の視力は？',
    options: [
      { optionId: '0', text: '2' },
      { optionId: '1', text: '0.2' },
      { optionId: '2', text: '0.8' },
      { optionId: '3', text: '1.5' },
      { optionId: '4', text: '3' },
    ],
  },
  {
    quizId: '12',
    question:
      '人探しで筒井雪隆の部屋を訪れた、取材や研究資料集めが目的の湖南研究所御抱えの特別捜査隊の通称は？',
    options: [
      { optionId: '0', text: 'ミッシングハンター' },
      { optionId: '1', text: '湖南特捜隊' },
      { optionId: '2', text: 'クリプティッドハンター' },
      { optionId: '3', text: 'アンアイデンティファイドハンター' },
      { optionId: '4', text: 'プラネットハンター' },
    ],
  },
  {
    quizId: '13',
    question: '江戸川美歩が10歳の頃、どんな理由で家出をした？',
    options: [
      { optionId: '0', text: '父親との大喧嘩' },
      { optionId: '1', text: '恋人に振られたから' },
      { optionId: '2', text: '部活の大会で迷惑をかけてから' },
      { optionId: '3', text: '父親が無関心だから' },
      { optionId: '4', text: '旅がしたくなったから' },
    ],
  },
  {
    quizId: '14',
    question:
      '江戸川美歩が10歳の頃、家出で鹿児島まで逃げたとき、どの程度の時間で捕まった？',
    options: [
      { optionId: '0', text: '36時間' },
      { optionId: '1', text: '10時間' },
      { optionId: '2', text: '24時間' },
      { optionId: '3', text: '30時間' },
      { optionId: '4', text: '45時間' },
    ],
  },
  {
    quizId: '15',
    question:
      'バカ王子・地球襲来編より問題です。\n王子が研究所の捜査隊に見つからないようにと、江戸川美歩が筒井雪隆にしたアドバイスとして間違っているのは？',
    options: [
      { optionId: '0', text: '今まで通りの生活を心がける' },
      { optionId: '1', text: '今はヘタに動かない方がいい' },
      { optionId: '2', text: '人目はなるべく避ける' },
      { optionId: '3', text: '夜は厚めのカーテンをしめる' },
      { optionId: '4', text: '昼はあまり窓に近づけさせないようにする' },
    ],
  },
  {
    quizId: '16',
    question:
      'バカ王子・地球襲来編より問題です。\n王子が湖南研究所から水晶データシステムを取り返し、筒井雪隆に正体を明かした後、喉が渇いたからと王子が筒井雪隆に要求した飲み物は？',
    options: [
      { optionId: '0', text: 'コーヒー' },
      { optionId: '1', text: '紅茶' },
      { optionId: '2', text: '牛乳' },
      { optionId: '3', text: 'オレンジジュース' },
      { optionId: '4', text: '水' },
    ],
  },
  {
    quizId: '17',
    question:
      'バカ王子・地球襲来編より問題です。\n王子が湖南研究所から水晶データシステムを取り返し、筒井雪隆に正体を明かした日、寝る前に筒井雪隆にした質問は？',
    options: [
      { optionId: '0', text: '好きな娘とかいる？' },
      { optionId: '1', text: '僕はどうなるのだろう？' },
      { optionId: '2', text: '明日は晴れるかな？' },
      { optionId: '3', text: '僕のことどう思っている？' },
      { optionId: '4', text: '変な音しない？' },
    ],
  },
  {
    quizId: '18',
    question:
      'バカ王子・地球襲来編より問題です。\nドグラ星王立護衛軍隊のサド隊員の護衛歴は？',
    options: [
      { optionId: '0', text: '5年' },
      { optionId: '1', text: '1年' },
      { optionId: '2', text: '2年' },
      { optionId: '3', text: '10年' },
      { optionId: '4', text: '15年' },
    ],
  },
  {
    quizId: '19',
    question:
      'バカ王子・地球襲来編より問題です。\n王子が筒井雪隆の部屋から抜け出した際に、雪隆へあてた書置きに書かれていなかったものは？',
    options: [
      { optionId: '0', text: '嬉しいですか？' },
      { optionId: '1', text: '元気ですか？' },
      { optionId: '2', text: '楽しいですか？' },
      { optionId: '3', text: '最高ですか？' },
      { optionId: '4', text: '特に何もないですか？' },
    ],
  },
  {
    quizId: '20',
    question: 'ディスクン星人の長が住んでいる家の住所は？',
    options: [
      { optionId: '0', text: '湖南町4丁目6番地' },
      { optionId: '1', text: '湖南町2丁目5番地' },
      { optionId: '2', text: '湖南町3丁目3番地' },
      { optionId: '3', text: '湖南町5丁目2番地' },
      { optionId: '4', text: '湖南町6丁目1番地' },
    ],
  },
  {
    quizId: '21',
    question: 'ディスクン星人の長の名前は？',
    options: [
      { optionId: '0', text: '坂本尽八' },
      { optionId: '1', text: '宮川忍' },
      { optionId: '2', text: '綿谷周' },
      { optionId: '3', text: '石田聡' },
      { optionId: '4', text: '細谷俊樹' },
    ],
  },
  {
    quizId: '22',
    question: 'ディスクン星人の仇敵はどこの星の人種？',
    options: [
      { optionId: '0', text: 'エラル星' },
      { optionId: '1', text: 'ジャクリンS星' },
      { optionId: '2', text: '惑星カルバリ' },
      { optionId: '3', text: 'ペギ星' },
      { optionId: '4', text: '惑星ホルン' },
    ],
  },
  {
    quizId: '23',
    question:
      'バカ王子・地球襲来編より問題です。\n筒井雪隆の部屋から抜け出した王子がショッピングをしていた店は？',
    options: [
      { optionId: '0', text: '松坂屋' },
      { optionId: '1', text: '松本屋' },
      { optionId: '2', text: '上坂屋' },
      { optionId: '3', text: '岡本屋' },
      { optionId: '4', text: '上原屋' },
    ],
  },
  {
    quizId: '24',
    question:
      'バカ王子・地球襲来編より問題です。\n王子を探していた筒井雪隆と江戸川美歩が喫茶店に入って、注文したものは？',
    options: [
      { optionId: '0', text: 'アイスコーヒー' },
      { optionId: '1', text: 'レモンティー' },
      { optionId: '2', text: 'オレンジジュース' },
      { optionId: '3', text: 'アイスカフェオレ' },
      { optionId: '4', text: 'ミルクティー' },
    ],
  },
  {
    quizId: '25',
    question:
      'バカ王子・地球襲来編より問題です。\n王子が喫茶店で筒井雪隆と江戸川美歩に相談した時、自分のことを何と表現していた？',
    options: [
      { optionId: '0', text: 'ある人' },
      { optionId: '1', text: 'Aさん' },
      { optionId: '2', text: '私' },
      { optionId: '3', text: 'ぼく' },
      { optionId: '4', text: '宇宙人' },
    ],
  },
  {
    quizId: '26',
    question:
      'バカ王子・地球襲来編より問題です。\n王子が見かけたモメ事、何人で女性に絡んでいた？',
    options: [
      { optionId: '0', text: '3人' },
      { optionId: '1', text: '2人' },
      { optionId: '2', text: '4人' },
      { optionId: '3', text: '5人' },
      { optionId: '4', text: '6人' },
    ],
  },
  {
    quizId: '27',
    question:
      'バカ王子・地球襲来編より問題です。\nモメ事を見かけた王子の台詞、\n「いやがっている人をムリヤリ誘うのは良くないよ」\n筒井雪隆的には何点？',
    options: [
      { optionId: '0', text: '5点' },
      { optionId: '1', text: '0点' },
      { optionId: '2', text: '2点' },
      { optionId: '3', text: '10点' },
      { optionId: '4', text: '13点' },
    ],
  },
  {
    quizId: '28',
    question:
      'バカ王子・地球襲来編より問題です。\n筒井雪隆の台詞より\n「上級者は無言で止めに入った奴を砂にして息の根を止めます」\n"砂にする”の意味は？',
    options: [
      { optionId: '0', text: 'フクロにする' },
      { optionId: '1', text: '刃物で刺す' },
      { optionId: '2', text: '骨を折る' },
      { optionId: '3', text: '攫う' },
      { optionId: '4', text: '鈍器で殴る' },
    ],
  },
  {
    quizId: '29',
    question:
      'バカ王子・地球襲来編より問題です。\n筒井雪隆の和英辞典は本棚のどこに置いてある？',
    options: [
      { optionId: '0', text: '上から2番目、左から3番目' },
      { optionId: '1', text: '上から2番目、右から5番目' },
      { optionId: '2', text: '下から2番目、左から4番目' },
      { optionId: '3', text: '下から3番目、右から2番目' },
      { optionId: '4', text: '上から3番目、右から7番目' },
    ],
  },
  {
    quizId: '30',
    question:
      'バカ王子・地球襲来編より問題です。\n王子は出席予定だった会議のテーマは何？',
    options: [
      { optionId: '0', text: '開発途上惑星との交流及び援助' },
      { optionId: '1', text: '異星間抗争の規制、撤廃' },
      { optionId: '2', text: '異星間の無断侵入禁止' },
      { optionId: '3', text: '絶滅のおそれのある希少種の保護' },
      { optionId: '4', text: '星間移動の航路検討' },
    ],
  },
  {
    quizId: '31',
    question:
      'クラフトの説明より問題です。\n異星人が地球人を誘拐する理由に無いものは？',
    options: [
      { optionId: '0', text: '人身売買' },
      { optionId: '1', text: '人体実験' },
      { optionId: '2', text: '食糧' },
      { optionId: '3', text: '労働奴隷' },
      { optionId: '4', text: '快楽玩具' },
    ],
  },
  {
    quizId: '32',
    question: 'No003 「Risky game!」の扉絵に描いてある診療科は？',
    options: [
      { optionId: '0', text: '小宇宙人科' },
      { optionId: '1', text: '小児科' },
      { optionId: '2', text: '脳外科' },
      { optionId: '3', text: '宇宙内科' },
      { optionId: '4', text: '脳細胞科' },
    ],
  },
  {
    quizId: '33',
    question:
      'コリンが江戸川美歩に王子の説明をする際、王子は素晴らしい頭脳をどのようなことに使うと説明している？',
    options: [
      { optionId: '0', text: '民衆の支持を下げず、いかに苦しめるか' },
      { optionId: '1', text: '怪我なく、いかにクラフトに危険な仕事を与えるか' },
      {
        optionId: '2',
        text: '犯罪としてひっかからないように、外交問題に首を突っ込む',
      },
      {
        optionId: '3',
        text: '自分の仕業と気づかせず、いかに近くで恐怖にゆがんだ顔を見るか',
      },
      {
        optionId: '4',
        text: 'クラフトに責任を押し付けつつ、城内で騒ぎを起こすか',
      },
    ],
  },
  {
    quizId: '34',
    question:
      'バカ王子・地球襲来編より問題です。\n街中で王子に殺されたふりをしたディスクン星人の名前は？',
    options: [
      { optionId: '0', text: 'ラファティ' },
      { optionId: '1', text: 'ミンディア' },
      { optionId: '2', text: 'スギゾウ' },
      { optionId: '3', text: 'ティレビィ' },
      { optionId: '4', text: 'ビャレル' },
    ],
  },
  {
    quizId: '35',
    question:
      'バカ王子・地球襲来編より問題です。\nディスクン星人の長は王子の計画協力を何を条件に引き受けた？',
    options: [
      { optionId: '0', text: '野茂のサインボールと大リーグカード一式' },
      { optionId: '1', text: '王貞治のサインバットと大リーグボールカード一式' },
      { optionId: '2', text: '長嶋茂雄のサイン色紙' },
      { optionId: '3', text: '落合博満のサインボールと甲子園の土' },
      { optionId: '4', text: '筒井雪隆のサイン色紙と甲子園の土' },
    ],
  },
  {
    quizId: '36',
    question:
      'バカ王子・地球襲来編より問題です。\n王子が水晶データシステムを取り返すために湖南研究所へ侵入する際、それらしき人物を眠らせて物色しましたが、何人目でカードを入手した？',
    options: [
      { optionId: '0', text: '3人目' },
      { optionId: '1', text: '1人目' },
      { optionId: '2', text: '2人目' },
      { optionId: '3', text: '4人目' },
      { optionId: '4', text: '5人目' },
    ],
  },
  {
    quizId: '37',
    question: '中学生当時に水泳部に所属していた江戸川美歩は何と呼ばれていた？',
    options: [
      { optionId: '0', text: '朝霞のトビ魚' },
      { optionId: '1', text: '朝霞のマグロ' },
      { optionId: '2', text: '朝霞のイルカ' },
      { optionId: '3', text: '朝霞のマーメイド' },
      { optionId: '4', text: '朝霞のダツ' },
    ],
  },
  {
    quizId: '38',
    question:
      'バカ王子・地球襲来編より問題です。\n王子が地球を去っておよそ3ヶ月、筒井雪隆が2つの大ニュースを報告しに来た際、江戸川美歩が手にしていた缶入り飲料は？',
    options: [
      { optionId: '0', text: '毛毛茶' },
      { optionId: '1', text: 'コッカコーラ' },
      { optionId: '2', text: '鳥龍茶' },
      { optionId: '3', text: 'ピルクス' },
      { optionId: '4', text: '王宙水' },
    ],
  },
  {
    quizId: '39',
    question:
      '食人鬼編より問題です。\nキャンプの際、A組の山本がD組の安田を食べるのを目撃した生徒でない者は？',
    options: [
      { optionId: '0', text: '松田' },
      { optionId: '1', text: '板倉' },
      { optionId: '2', text: '山田' },
      { optionId: '3', text: '東尾' },
      { optionId: '4', text: '野崎' },
    ],
  },
  {
    quizId: '40',
    question:
      '食人鬼編より問題です。\n集合時間に遅れた生徒に説教して、キャンプファイヤーの準備時間を遅らせてしまっていた教師は？',
    options: [
      { optionId: '0', text: '谷町' },
      { optionId: '1', text: '弓川' },
      { optionId: '2', text: '北山' },
      { optionId: '3', text: '吉井' },
      { optionId: '4', text: '中村' },
    ],
  },
  {
    quizId: '41',
    question: '食人鬼編より問題です。\nC組の前原の身長はおよそ何cm？',
    options: [
      { optionId: '0', text: '180cm' },
      { optionId: '1', text: '150cm' },
      { optionId: '2', text: '160cm' },
      { optionId: '3', text: '170cm' },
      { optionId: '4', text: '190cm' },
    ],
  },
  {
    quizId: '42',
    question:
      '食人鬼編より問題です。\n東尾達が坂本庵悟に精神クリニックを紹介してもらった際の仲介料は？',
    options: [
      { optionId: '0', text: '2万' },
      { optionId: '1', text: '1万' },
      { optionId: '2', text: '3万' },
      { optionId: '3', text: '5万' },
      { optionId: '4', text: '10万' },
    ],
  },
  {
    quizId: '43',
    question:
      '食人鬼編より問題です。\n東尾達が坂本庵悟に紹介してもらった精神クリニックの名前は？',
    options: [
      { optionId: '0', text: 'YUMENO メンタルクリニック' },
      { optionId: '1', text: '夢野 メンタルクリニック' },
      { optionId: '2', text: 'ゆめの メンタルクリニック' },
      { optionId: '3', text: 'ユメノ メンタルクリニック' },
      { optionId: '4', text: '夢のメンタルクリニック' },
    ],
  },
  {
    quizId: '44',
    question:
      '食人鬼編より問題です。\n精神クリニックの受信コースは、本来Aから何コースまである？',
    options: [
      { optionId: '0', text: 'Cコース' },
      { optionId: '1', text: 'Aコース' },
      { optionId: '2', text: 'Bコース' },
      { optionId: '3', text: 'Dコース' },
      { optionId: '4', text: 'Eコース' },
    ],
  },
  {
    quizId: '45',
    question:
      '食人鬼編より問題です。\n精神クリニックで夢野先生に化け物調査を依頼すると、調査日数を1週間として、基本調査料はいくらになる？',
    options: [
      { optionId: '0', text: '150万' },
      { optionId: '1', text: '80万' },
      { optionId: '2', text: '100万' },
      { optionId: '3', text: '200万' },
      { optionId: '4', text: '250万' },
    ],
  },
  {
    quizId: '46',
    question:
      '夢野先生が調査料の目安として便宜上作成した分類では、コンウェル星人は何に分類される？',
    options: [
      { optionId: '0', text: '密着型Ⅱタイプ' },
      { optionId: '1', text: '密着型Ⅰタイプ' },
      { optionId: '2', text: '潜伏型Ⅱタイプ' },
      { optionId: '3', text: '潜伏型Ⅰタイプ' },
      { optionId: '4', text: '同化型Ⅲタイプ' },
    ],
  },
  {
    quizId: '47',
    question: '精神クリニックの夢野先生のフルネームは？',
    options: [
      { optionId: '0', text: '夢野九四郎' },
      { optionId: '1', text: '夢野十郎太' },
      { optionId: '2', text: '夢野悠一' },
      { optionId: '3', text: '夢野智一' },
      { optionId: '4', text: '夢野千尋' },
    ],
  },
  {
    quizId: '48',
    question:
      '食人鬼編より問題です。\n調査を依頼した時に、保護のために住まわされる夢野の部屋は何階にある？',
    options: [
      { optionId: '0', text: '7階' },
      { optionId: '1', text: '3階' },
      { optionId: '2', text: '5階' },
      { optionId: '3', text: '9階' },
      { optionId: '4', text: '11階' },
    ],
  },
  {
    quizId: '49',
    question:
      '食人鬼編より問題です。\n野崎が夢野先生に調査を依頼した際、被っていた帽子に書かれていたの文字は？',
    options: [
      { optionId: '0', text: 'V・T' },
      { optionId: '1', text: '四面楚歌' },
      { optionId: '2', text: '涼' },
      { optionId: '3', text: '岩田硝子' },
      { optionId: '4', text: 'MMR' },
    ],
  },
  {
    quizId: '50',
    question: '精神クリニックを勤めている夢野の父親の職業は？',
    options: [
      { optionId: '0', text: '生物学者' },
      { optionId: '1', text: '考古学者' },
      { optionId: '2', text: '作家' },
      { optionId: '3', text: 'オカルト記者' },
      { optionId: '4', text: '医者' },
    ],
  },
  {
    quizId: '51',
    question: '夢野先生は何歳の頃からネッシーなどのUMA調査隊に同行している？',
    options: [
      { optionId: '0', text: '13歳' },
      { optionId: '1', text: '6歳' },
      { optionId: '2', text: '8歳' },
      { optionId: '3', text: '11歳' },
      { optionId: '4', text: '15歳' },
    ],
  },
  {
    quizId: '52',
    question: '食人鬼編より問題です。\nコンウェル星である山本の父親の職業は？',
    options: [
      { optionId: '0', text: '土建業' },
      { optionId: '1', text: '食料製造業' },
      { optionId: '2', text: '保険業' },
      { optionId: '3', text: '運輸業' },
      { optionId: '4', text: '水産業' },
    ],
  },
  {
    quizId: '53',
    question: '夢野の言っていた山本弟の学校での評判として間違っているものは？',
    options: [
      { optionId: '0', text: '挙動不審' },
      { optionId: '1', text: '活発' },
      { optionId: '2', text: '社交的' },
      { optionId: '3', text: '不気味' },
      { optionId: '4', text: '乱暴' },
    ],
  },
  {
    quizId: '54',
    question:
      '食物ではなく女性を食べないと満たされず、頭のどこかで飢えていることを、コンウェル星人は何と呼ぶ？',
    options: [
      { optionId: '0', text: '見えない胃袋' },
      { optionId: '1', text: '欲の飢餓' },
      { optionId: '2', text: '満たない胃袋' },
      { optionId: '3', text: '第二の胃袋' },
      { optionId: '4', text: '胃袋の向こう側' },
    ],
  },
  {
    quizId: '55',
    question:
      '食人鬼編より問題です。\n夢野先生は調査対象を絞ってくれていたからと、調査費を4人でまとめていくらにまけてくれた？',
    options: [
      { optionId: '0', text: '100万' },
      { optionId: '1', text: '50万' },
      { optionId: '2', text: '80万' },
      { optionId: '3', text: '120万' },
      { optionId: '4', text: '150万' },
    ],
  },
  {
    quizId: '56',
    question: '食人鬼編より問題です。\n東尾の彼女の名前は？',
    options: [
      { optionId: '0', text: '成美' },
      { optionId: '1', text: '由衣' },
      { optionId: '2', text: '葵' },
      { optionId: '3', text: '沙織' },
      { optionId: '4', text: 'あやめ' },
    ],
  },
  {
    quizId: '57',
    question: 'No.006の扉絵で黛が読んでいる本のタイトルは？',
    options: [
      { optionId: '0', text: '唯物論と宗教' },
      { optionId: '1', text: '少女地獄' },
      { optionId: '2', text: '少年犯罪の深層心理' },
      { optionId: '3', text: '努々の夢' },
      { optionId: '4', text: '生物と微生物の間' },
    ],
  },
  {
    quizId: '58',
    question:
      '原色戦隊カラーレンジャー編より問題です。\n赤川達5人が王子に攫われた際、黛は何が理由で早く帰りたがっていた？',
    options: [
      { optionId: '0', text: 'オシッコして寝たいから' },
      { optionId: '1', text: '面倒だから' },
      { optionId: '2', text: '早く本が読みたいから' },
      { optionId: '3', text: '塾の時間に遅れるから' },
      { optionId: '4', text: '待ち合わせに遅れるから' },
    ],
  },
  {
    quizId: '59',
    question:
      '原色戦隊カラーレンジャー編より問題です。\n赤川達5人が王子に攫われた際、何時何分に王子の言うとおりにするように決意した？',
    options: [
      { optionId: '0', text: '0.211805555555556' },
      { optionId: '1', text: '0.1875' },
      { optionId: '2', text: '0.239583333333333' },
      { optionId: '3', text: '6時' },
      { optionId: '4', text: '0.263888888888889' },
    ],
  },
  {
    quizId: '60',
    question:
      '原色戦隊カラーレンジャー編より問題です。\n黛は王子に攫われた日に、どのような夢を見た？',
    options: [
      {
        optionId: '0',
        text: 'ナス色のお姫様がヒキガエルの子供とくるくる回る夢',
      },
      { optionId: '1', text: '自分がヒーローになって平和な町で暮らす夢' },
      { optionId: '2', text: '空から落ちてきた小さな卵を、空へ返しに行く夢' },
      { optionId: '3', text: '学校の帰り道で、白猫にワンと吠えられる夢' },
      {
        optionId: '4',
        text: '夢の中で寝たら、更にその中で眠る自分を俯瞰している夢',
      },
    ],
  },
  {
    quizId: '61',
    question:
      '原色戦隊カラーレンジャー編より問題です。\n王子に攫われてヒーローになった翌日、興奮している赤川を蹴った横田のコマンドは？',
    options: [
      { optionId: '0', text: '←←K（↙↙P+K）' },
      { optionId: '1', text: '↓↙←K' },
      { optionId: '2', text: '↓↓K(↘↘P)' },
      { optionId: '3', text: '←↙↓↘→K' },
      { optionId: '4', text: '←→←LK' },
    ],
  },
  {
    quizId: '62',
    question:
      '原色戦隊カラーレンジャー編より問題です。\n赤川が学校で赤の戦士に変身し、立花先生の正体を見たとき、トイレで立花先生を何と表現していた？',
    options: [
      { optionId: '0', text: 'トカゲ' },
      { optionId: '1', text: 'ヘビ' },
      { optionId: '2', text: 'ワニ' },
      { optionId: '3', text: 'イモリ' },
      { optionId: '4', text: '恐竜' },
    ],
  },
  {
    quizId: '63',
    question:
      '赤川達の担任の立花先生、彼女の夢は教師になることともう一つは何？',
    options: [
      { optionId: '0', text: '宇宙をくまなく旅行する' },
      { optionId: '1', text: '地球で平和に暮らし続ける' },
      { optionId: '2', text: '仕事をせずに一生豪遊する' },
      { optionId: '3', text: '結婚して子供を2人作る' },
      { optionId: '4', text: '自分の故郷に帰る' },
    ],
  },
  {
    quizId: '64',
    question:
      '原色戦隊カラーレンジャー編より問題です。\nカラーレンジャーになりたての清水たちがレベル1の状態でぶちスライムを倒すのに数ターンかかるカスなのに対し、クラフト魔人は絶好調時の何より強い？',
    options: [
      { optionId: '0', text: 'ムドー' },
      { optionId: '1', text: 'ゾーマ' },
      { optionId: '2', text: 'シドー' },
      { optionId: '3', text: 'ハーゴン' },
      { optionId: '4', text: 'エスターク' },
    ],
  },
  {
    quizId: '65',
    question: '白の戦士、レベル2の能力は何？',
    options: [
      { optionId: '0', text: 'バトルシップ' },
      { optionId: '1', text: 'バトルチンキ' },
      { optionId: '2', text: 'バトルメディシン' },
      { optionId: '3', text: 'バトルテーピング' },
      { optionId: '4', text: 'バトルケア' },
    ],
  },
  {
    quizId: '66',
    question: '黒の戦士、レベル2の能力「バトルアンハッピー2」の効果は？',
    options: [
      { optionId: '0', text: '黒猫を横切らせて、敵を不安にする' },
      { optionId: '1', text: 'クツのヒモを切り、敵を不安にする' },
      { optionId: '2', text: 'カラスを呼び寄せ、敵を不安にする' },
      { optionId: '3', text: '足元に櫛を落とし、敵を不安にする' },
      { optionId: '4', text: '冒険の書が消えた音で、敵を不安にする' },
    ],
  },
  {
    quizId: '67',
    question: 'カラーレンジャーの説明書に書かれていない武器は？',
    options: [
      { optionId: '0', text: '手榴弾' },
      { optionId: '1', text: '金づち' },
      { optionId: '2', text: '猟銃' },
      { optionId: '3', text: '戦闘機' },
      { optionId: '4', text: '核ミサイル' },
    ],
  },
  {
    quizId: '68',
    question:
      'カラーレンジャーの説明書の使用上の注意には、長時間の着用は肉体疲労の原因となるので、1日どの程度にするよう書かれている？',
    options: [
      { optionId: '0', text: '1時間' },
      { optionId: '1', text: '3時間' },
      { optionId: '2', text: '5時間' },
      { optionId: '3', text: '10時間' },
      { optionId: '4', text: '24時間' },
    ],
  },
  {
    quizId: '69',
    question: '清水がレベル2になった時に上昇したパラメータは？',
    options: [
      { optionId: '0', text: 'かしこさ' },
      { optionId: '1', text: 'ちから' },
      { optionId: '2', text: 'すばやさ' },
      { optionId: '3', text: 'HP' },
      { optionId: '4', text: '身のまもり' },
    ],
  },
  {
    quizId: '70',
    question:
      '赤原色戦隊カラーレンジャー編より問題です。\nの戦士、レベル10の能力「リルボム」を清水たちに紹介するとき、対象としたものは？',
    options: [
      { optionId: '0', text: '空き缶' },
      { optionId: '1', text: '岩' },
      { optionId: '2', text: '小石' },
      { optionId: '3', text: '看板' },
      { optionId: '4', text: 'トーテムポール' },
    ],
  },
  {
    quizId: '71',
    question:
      '原色戦隊カラーレンジャー編より問題です。\nクラフト魔人を倒すため山形へ向かうカラーレンジャー、何時に東京駅に集合した？',
    options: [
      { optionId: '0', text: '8時' },
      { optionId: '1', text: '6時' },
      { optionId: '2', text: '10時' },
      { optionId: '3', text: '12時' },
      { optionId: '4', text: '2時' },
    ],
  },
  {
    quizId: '72',
    question:
      '百池がリングを外すための暗号で言っていなかった、女の子の名前は？',
    options: [
      { optionId: '0', text: 'レベッカ=モーネイ' },
      { optionId: '1', text: '遠山景子' },
      { optionId: '2', text: '辺見笑' },
      { optionId: '3', text: '加賀時子' },
      { optionId: '4', text: '高田麻美' },
    ],
  },
  {
    quizId: '73',
    question:
      '百池がリングを外すための暗号で言っていなかった、女の子の名前は？',
    options: [
      { optionId: '0', text: '高橋真由美' },
      { optionId: '1', text: '矢部秋穂' },
      { optionId: '2', text: '島田翔子' },
      { optionId: '3', text: '広美令' },
      { optionId: '4', text: 'シェリー=エイブラハムズ' },
    ],
  },
  {
    quizId: '74',
    question:
      '原色戦隊カラーレンジャー編より問題です。\nカラーレンジャーのゲーム舞台になった星の名前は？',
    options: [
      { optionId: '0', text: '惑星カルバリ' },
      { optionId: '1', text: 'ペギ星' },
      { optionId: '2', text: 'ジャクリンS星' },
      { optionId: '3', text: 'エラル星' },
      { optionId: '4', text: '惑星ホルン' },
    ],
  },
  {
    quizId: '75',
    question:
      'カ原色戦隊カラーレンジャー編より問題です。\nゲームを始めて最初に会った敵のレベルはどこに書かれていた？',
    options: [
      { optionId: '0', text: '金玉の裏' },
      { optionId: '1', text: '足の裏' },
      { optionId: '2', text: '石オノ' },
      { optionId: '3', text: '背中' },
      { optionId: '4', text: '頭のてっぺん' },
    ],
  },
  {
    quizId: '76',
    question:
      '原色戦隊カラーレンジャー編より問題です。\nゲーム世界で清水たちが見かけた看板には、始まりの町までどのくらいと書かれていた？',
    options: [
      { optionId: '0', text: 'この先？km' },
      { optionId: '1', text: 'この先少し' },
      { optionId: '2', text: 'この先2km' },
      { optionId: '3', text: 'この先2時間' },
      { optionId: '4', text: 'この先30分' },
    ],
  },
  {
    quizId: '77',
    question: '原色戦隊カラーレンジャー編より問題です。\n始まりの町の名前は？',
    options: [
      { optionId: '0', text: 'ハマジリ' },
      { optionId: '1', text: 'タートス' },
      { optionId: '2', text: 'ショサイ' },
      { optionId: '3', text: 'ケンボー' },
      { optionId: '4', text: 'カシイ' },
    ],
  },
  {
    quizId: '78',
    question:
      '横田にしたRPGの説明の簡単例で、仙人のところへ行くために必要なものは何とされている？',
    options: [
      { optionId: '0', text: '天界の船' },
      { optionId: '1', text: '魔法の絨毯' },
      { optionId: '2', text: '漂流島' },
      { optionId: '3', text: 'マグマの杖' },
      { optionId: '4', text: '最終のカギ' },
    ],
  },
  {
    quizId: '79',
    question:
      '原色戦隊カラーレンジャー編より問題です。\n始まりの町からみてイイダチ城はどの方角に2kmのところにある？',
    options: [
      { optionId: '0', text: '南' },
      { optionId: '1', text: '西' },
      { optionId: '2', text: '北' },
      { optionId: '3', text: '東' },
      { optionId: '4', text: '北西' },
    ],
  },
  {
    quizId: '80',
    question: '赤川達の通っている小学校の理事長は誰？',
    options: [
      { optionId: '0', text: '百池の祖父' },
      { optionId: '1', text: '百池の父' },
      { optionId: '2', text: '百池の母' },
      { optionId: '3', text: '百池の祖母' },
      { optionId: '4', text: '百池の曽祖父' },
    ],
  },
  {
    quizId: '81',
    question:
      '青の戦士、レベル2の能力「バトルポカリ」で出したドリンクの容器に書かれている文字は？',
    options: [
      { optionId: '0', text: 'P' },
      { optionId: '1', text: 'A' },
      { optionId: '2', text: 'B' },
      { optionId: '3', text: 'W' },
      { optionId: '4', text: '？' },
    ],
  },
  {
    quizId: '82',
    question:
      'ゲームにはまる兆候のキーワード、\n「～さえ何とかなればなぁ」\nに当てはまる清水の不満は？',
    options: [
      { optionId: '0', text: 'MPの設定がちょっと少ない点' },
      { optionId: '1', text: 'レベルアップまでが長い点' },
      { optionId: '2', text: '実際に死ぬ恐れがある点' },
      { optionId: '3', text: '王子が盗み聞きしてる点' },
      { optionId: '4', text: '突然さらわれて強制参加させられている点' },
    ],
  },
  {
    quizId: '83',
    question:
      '原色戦隊カラーレンジャー編より問題です。\nイイダチ城へ行くときの百池のレベルは？',
    options: [
      { optionId: '0', text: '45' },
      { optionId: '1', text: '35' },
      { optionId: '2', text: '36' },
      { optionId: '3', text: '50' },
      { optionId: '4', text: '71' },
    ],
  },
  {
    quizId: '84',
    question:
      '原色戦隊カラーレンジャー編より問題です。\nイイダチ王の娘で、イイダチ城の姫の名前は？',
    options: [
      { optionId: '0', text: 'アパレル' },
      { optionId: '1', text: 'ツキレン' },
      { optionId: '2', text: 'マイオリ' },
      { optionId: '3', text: 'ポステル' },
      { optionId: '4', text: 'ククリ' },
    ],
  },
  {
    quizId: '85',
    question:
      '原色戦隊カラーレンジャー編より問題です。\nイイダチ城で姫に扮する王子を殴ったのは誰？',
    options: [
      { optionId: '0', text: '清水' },
      { optionId: '1', text: '赤川' },
      { optionId: '2', text: '横田' },
      { optionId: '3', text: '百池' },
      { optionId: '4', text: '黛' },
    ],
  },
  {
    quizId: '86',
    question:
      '原色戦隊カラーレンジャー編より問題です。\n姫に扮する王子は、ゲーム世界から容易に脱出できないことに気付き、何の続編を作るべきでないと現実逃避した？',
    options: [
      { optionId: '0', text: '映画のエイリアン' },
      { optionId: '1', text: '金八先生' },
      { optionId: '2', text: 'ジョーズ' },
      { optionId: '3', text: '映画のターミネーター' },
      { optionId: '4', text: '映画のゴッドファーザー' },
    ],
  },
  {
    quizId: '87',
    question:
      '原色戦隊カラーレンジャー編より問題です。\n暗黒空軍竜騎士隊隊長のルチ将軍のレベルは？',
    options: [
      { optionId: '0', text: '1300' },
      { optionId: '1', text: '1100' },
      { optionId: '2', text: '1200' },
      { optionId: '3', text: '1400' },
      { optionId: '4', text: '1500' },
    ],
  },
  {
    quizId: '88',
    question:
      '原色戦隊カラーレンジャー編より問題です。\n魔王は体長を最大でどこまで大きくできる？',
    options: [
      { optionId: '0', text: '15m' },
      { optionId: '1', text: '25m' },
      { optionId: '2', text: '50m' },
      { optionId: '3', text: '100m' },
      { optionId: '4', text: '無限' },
    ],
  },
  {
    quizId: '89',
    question:
      '原色戦隊カラーレンジャー編より問題です。\nルチ将軍が新婚初夜に向けて、知識を得るために読んでいた本は？',
    options: [
      { optionId: '0', text: '明るい男女交際' },
      { optionId: '1', text: '初めての夜のため' },
      { optionId: '2', text: '困らないためのあれやこれ' },
      { optionId: '3', text: '新婚の過ごし方' },
      { optionId: '4', text: '嫌われやすいあなたへ' },
    ],
  },
  {
    quizId: '90',
    question: '赤の戦士、レベル120の能力は？',
    options: [
      { optionId: '0', text: 'バスガス爆発×3' },
      { optionId: '1', text: 'バスガス爆発' },
      { optionId: '2', text: 'バスガス爆発×2' },
      { optionId: '3', text: 'バスガス爆発×3' },
      { optionId: '4', text: 'バスガス爆発×4' },
    ],
  },
  {
    quizId: '91',
    question:
      '青の戦士、レベル200の能力「蛙ぴょこぴょこみぴょこぴょこ あわせてぴょこぴょこみぴょこぴょこ」は何秒以内に言わなければならない？',
    options: [
      { optionId: '0', text: '2.5秒以内' },
      { optionId: '1', text: '2秒以内' },
      { optionId: '2', text: '3.5秒以内' },
      { optionId: '3', text: '5秒以内' },
      { optionId: '4', text: '無制限' },
    ],
  },
  {
    quizId: '92',
    question:
      '白の戦士、レベル200の能力「オジャパメンをフルコーラス」の効用は？',
    options: [
      { optionId: '0', text: '味方全員のMP200回復' },
      { optionId: '1', text: '味方全員の重傷を癒す' },
      { optionId: '2', text: '味方全員の軽傷を癒す' },
      { optionId: '3', text: '味方全員のMP100回復' },
      { optionId: '4', text: '味方全員の状態異常を治す' },
    ],
  },
  {
    quizId: '93',
    question:
      '原色戦隊カラーレンジャー編より問題です。\nルチ将軍との結婚が条件で、ルチ将軍のベッドの下を調べると手に入るアイテムは？',
    options: [
      { optionId: '0', text: 'スカイボード' },
      { optionId: '1', text: 'エアボード' },
      { optionId: '2', text: 'フロートボード' },
      { optionId: '3', text: 'ウィンドボード' },
      { optionId: '4', text: 'フライボード' },
    ],
  },
  {
    quizId: '94',
    question:
      '原色戦隊カラーレンジャー編より問題です。\n王子とルチ将軍の結婚初夜、王子はどのようなシチュエーションを命じて抜け出した？',
    options: [
      { optionId: '0', text: '居残りを命じられた生徒とそれを忘れた女教師' },
      { optionId: '1', text: '怪我の治療を後回しにされる患者と女医師' },
      { optionId: '2', text: '待ち合わせに遅れる彼女と、待つ彼氏' },
      { optionId: '3', text: '仕事を押し付けられた部下と、その上司' },
      { optionId: '4', text: 'お仕置きとして部屋に閉じ込められた子と、その母' },
    ],
  },
  {
    quizId: '95',
    question:
      '原色戦隊カラーレンジャー編より問題です。\n聖者のほこらはどんな仕組みが施されているが故に、魔族が侵入できない？',
    options: [
      { optionId: '0', text: '磁気ガード' },
      { optionId: '1', text: '聖水による結界' },
      { optionId: '2', text: '電磁波ガード' },
      { optionId: '3', text: '超音波ガード' },
      { optionId: '4', text: '不思議バリア' },
    ],
  },
  {
    quizId: '96',
    question:
      '5人の色の力を合わせた能力「ゴールデンハンマー」\n出てくる手に付いているブレスレットには何と書いてある？',
    options: [
      { optionId: '0', text: '怒' },
      { optionId: '1', text: '正義' },
      { optionId: '2', text: '金槌' },
      { optionId: '3', text: '合' },
      { optionId: '4', text: '罰' },
    ],
  },
  {
    quizId: '97',
    question:
      '原色戦隊カラーレンジャー編より問題です。\nゲームの舞台となった星から地球まで3時間で帰ることができる航路は？',
    options: [
      { optionId: '0', text: '銀河ワームホール航路' },
      { optionId: '1', text: '銀河ハンルーラ航路' },
      { optionId: '2', text: '宇宙キメラ航路' },
      { optionId: '3', text: '宇宙ビダッシュ航路' },
      { optionId: '4', text: 'アマガワ航路' },
    ],
  },
  {
    quizId: '98',
    question:
      '原色戦隊カラーレンジャー編より問題です。\nゲームの舞台となった星から地球まで、一般航路で帰った場合、どの程度時間がかかる？',
    options: [
      { optionId: '0', text: '116億年' },
      { optionId: '1', text: '500年' },
      { optionId: '2', text: '5億年' },
      { optionId: '3', text: '37億年' },
      { optionId: '4', text: '84億年' },
    ],
  },
  {
    quizId: '99',
    question: '地球へやってきたマクバク族の女王の名前は？',
    options: [
      { optionId: '0', text: 'サキ' },
      { optionId: '1', text: 'ジュリ' },
      { optionId: '2', text: 'ミク' },
      { optionId: '3', text: 'メル' },
      { optionId: '4', text: 'ノノカ' },
    ],
  },
  {
    quizId: '100',
    question: 'マクバク族の寿命は？',
    options: [
      { optionId: '0', text: '200～500年程度' },
      { optionId: '1', text: '70年程度' },
      { optionId: '2', text: '100年程度' },
      { optionId: '3', text: '500～600年程度' },
      { optionId: '4', text: '1000年程度' },
    ],
  },
  {
    quizId: '101',
    question:
      'マクバク族が地球へ来るという情報をサドが持ってきたときに、コリンが来ていた服には何と書いてあった？',
    options: [
      { optionId: '0', text: 'MMR' },
      { optionId: '1', text: '四面楚歌' },
      { optionId: '2', text: '涼' },
      { optionId: '3', text: '岩田硝子' },
      { optionId: '4', text: 'V・T' },
    ],
  },
  {
    quizId: '102',
    question:
      'マクバク族が地球へ来たとき、サドたちの中では王子はどこで何をしている予定だった？',
    options: [
      { optionId: '0', text: '東南アジアで薬草集め' },
      { optionId: '1', text: '筒井雪隆の家でサプライズ準備' },
      { optionId: '2', text: 'ドグラ星で会議' },
      { optionId: '3', text: '沖縄で旅行' },
      { optionId: '4', text: 'どこかで新種の生物研究' },
    ],
  },
  {
    quizId: '103',
    question:
      'クラフトがマクバク族へ地球人の説明をしたとき、地球人が差別をする理由の例としてあげられていないものは？',
    options: [
      { optionId: '0', text: '性格' },
      { optionId: '1', text: '地位' },
      { optionId: '2', text: '見た目' },
      { optionId: '3', text: '個性' },
      { optionId: '4', text: '肌の色' },
    ],
  },
  {
    quizId: '104',
    question:
      'クラフトがマクバク族へ地球人の説明をしたとき、地球人がしていることの例としてあげられていないものは？',
    options: [
      { optionId: '0', text: '同星生物の淘汰' },
      { optionId: '1', text: 'フロンガスの大量排出' },
      { optionId: '2', text: '過剰な森林伐採' },
      { optionId: '3', text: 'CO2の大量排出' },
      { optionId: '4', text: '廃物不法投棄' },
    ],
  },
  {
    quizId: '105',
    question:
      'サドが話していた、マクバク族に関する興味深い話の一つであげた論文のタイトルは？',
    options: [
      { optionId: '0', text: '一目ぼれは遺伝子の合図' },
      { optionId: '1', text: '一目ぼれの可能性' },
      { optionId: '2', text: '科学による愛' },
      { optionId: '3', text: '人間の遺伝子的つながり' },
      { optionId: '4', text: '種のための個' },
    ],
  },
  {
    quizId: '106',
    question:
      'マクバク族サキ王女・ムコ探し編より問題です。\n幹久今日子と一緒にホテルへ来ていた女の名前は？',
    options: [
      { optionId: '0', text: 'サトミ' },
      { optionId: '1', text: 'リカ' },
      { optionId: '2', text: 'えみり' },
      { optionId: '3', text: '恵美' },
      { optionId: '4', text: '杏里' },
    ],
  },
  {
    quizId: '107',
    question: 'マクバク族が幹久今日子に伝えた待ち合わせ場所は？',
    options: [
      { optionId: '0', text: '霜森林公園' },
      { optionId: '1', text: '夢森林公園' },
      { optionId: '2', text: '風森林公園' },
      { optionId: '3', text: '心森林公園' },
      { optionId: '4', text: '憩いの森公園' },
    ],
  },
  {
    quizId: '108',
    question:
      '幹久今日子は脳の神経核の何が男性並みに大きいので体が女、心が男の状態になっていると思われる？',
    options: [
      { optionId: '0', text: 'INAH-3' },
      { optionId: '1', text: 'INAH-2' },
      { optionId: '2', text: 'INAH-1' },
      { optionId: '3', text: 'INAH-4' },
      { optionId: '4', text: 'INAH-5' },
    ],
  },
  {
    quizId: '109',
    question: 'マクバク族の女王に一目ぼれした幹久今日子は何歳？',
    options: [
      { optionId: '0', text: '19歳' },
      { optionId: '1', text: '16歳' },
      { optionId: '2', text: '17歳' },
      { optionId: '3', text: '18歳' },
      { optionId: '4', text: '20歳' },
    ],
  },
  {
    quizId: '110',
    question:
      'マクバク族による地球人全滅の危機を救う方法をクラフトへ話す直前に王子が読んでいた本のタイトルは？',
    options: [
      { optionId: '0', text: '少女地獄' },
      { optionId: '1', text: '唯物論と宗教' },
      { optionId: '2', text: '少年犯罪の深層心理' },
      { optionId: '3', text: '努々の夢' },
      { optionId: '4', text: '生物と微生物の間' },
    ],
  },
  {
    quizId: '111',
    question:
      '現在地球人の遺伝子は様々なものによって傷付けられているとあるが、その原因として挙げられていないものは？',
    options: [
      { optionId: '0', text: '人間の無知' },
      { optionId: '1', text: '過度の紫外線' },
      { optionId: '2', text: '家電製品による電磁波非熱効果' },
      { optionId: '3', text: '未知のウイルス' },
      { optionId: '4', text: '宇宙からくる放射線' },
    ],
  },
  {
    quizId: '112',
    question:
      '如月高校野球部主将岩田が甲子園地区予選決勝前日に着ていた服に書かれている文字は？',
    options: [
      { optionId: '0', text: '岩田硝子' },
      { optionId: '1', text: 'MMR' },
      { optionId: '2', text: '四面楚歌' },
      { optionId: '3', text: '涼' },
      { optionId: '4', text: 'V・T' },
    ],
  },
  {
    quizId: '113',
    question:
      '如月高校野球部エースの江尻、\n「○○を投げたら君への合図」\n○○は何？',
    options: [
      { optionId: '0', text: 'フォーク' },
      { optionId: '1', text: 'スライダー' },
      { optionId: '2', text: 'カーブ' },
      { optionId: '3', text: 'シュート' },
      { optionId: '4', text: '150km/h以上のストレート' },
    ],
  },
  {
    quizId: '114',
    question: '如月高校野球部、レギュラー陣の内、キャッチャーは誰？',
    options: [
      { optionId: '0', text: '倉本' },
      { optionId: '1', text: '江尻' },
      { optionId: '2', text: '所沢' },
      { optionId: '3', text: '佐藤' },
      { optionId: '4', text: '寺門' },
    ],
  },
  {
    quizId: '115',
    question: '如月高校野球部、レギュラー陣の内、セカンドは誰？',
    options: [
      { optionId: '0', text: '佐藤' },
      { optionId: '1', text: '倉本' },
      { optionId: '2', text: '所沢' },
      { optionId: '3', text: '江尻' },
      { optionId: '4', text: '寺門' },
    ],
  },
  {
    quizId: '116',
    question: '筒井雪隆のポジションは？',
    options: [
      { optionId: '0', text: 'レフト' },
      { optionId: '1', text: 'ファースト' },
      { optionId: '2', text: 'ライト' },
      { optionId: '3', text: 'センター' },
      { optionId: '4', text: 'サード' },
    ],
  },
  {
    quizId: '117',
    question: '如月高校野球部、主将にぞっこんのマネージャーは？',
    options: [
      { optionId: '0', text: '藤井' },
      { optionId: '1', text: '安藤' },
      { optionId: '2', text: '浅井' },
      { optionId: '3', text: '岡垣' },
      { optionId: '4', text: '古澤' },
    ],
  },
  {
    quizId: '118',
    question:
      '如月高校野球部で頻発しているポルターガイスト、主将の岩田は何と勘違いして覚えている？',
    options: [
      { optionId: '0', text: 'ポルノガイジン' },
      { optionId: '1', text: 'ポルターミスト' },
      { optionId: '2', text: 'ポークロースト' },
      { optionId: '3', text: 'ポルピエール' },
      { optionId: '4', text: 'ポルトガルガイド' },
    ],
  },
  {
    quizId: '119',
    question:
      '如月高校野球部、控えの田中が以前甲子園に来た時は、どの試合を見に来た？',
    options: [
      { optionId: '0', text: '巨人 – 阪神' },
      { optionId: '1', text: '沖縄水産 -  福岡第一' },
      { optionId: '2', text: '浦和市立 – 広島商' },
      { optionId: '3', text: '天理 – 丸亀' },
      { optionId: '4', text: '山陽 – 日大鶴ヶ丘' },
    ],
  },
  {
    quizId: '120',
    question:
      '如月高校野球部、控えの田中が以前甲子園に来た時に、どの席にシールを貼った？',
    options: [
      { optionId: '0', text: '15段の41' },
      { optionId: '1', text: '13段の35' },
      { optionId: '2', text: '15段の20' },
      { optionId: '3', text: '13段の6' },
      { optionId: '4', text: '12段の8' },
    ],
  },
  {
    quizId: '121',
    question: '如月高校野球部主将岩田の背番号は？',
    options: [
      { optionId: '0', text: '9' },
      { optionId: '1', text: '1' },
      { optionId: '2', text: '3' },
      { optionId: '3', text: '4' },
      { optionId: '4', text: '8' },
    ],
  },
  {
    quizId: '122',
    question:
      '湖南市民球場、室内練習場の壁に貼られた注意書きはどの文字が貼りなおされている？',
    options: [
      { optionId: '0', text: '火' },
      { optionId: '1', text: '大' },
      { optionId: '2', text: '暖' },
      { optionId: '3', text: '使' },
      { optionId: '4', text: '点' },
    ],
  },
  {
    quizId: '123',
    question: '湖南市民球場、室内練習場の隅に置かれている洗濯機の色は？',
    options: [
      { optionId: '0', text: 'うす緑' },
      { optionId: '1', text: 'ベージュ' },
      { optionId: '2', text: '白' },
      { optionId: '3', text: '群青' },
      { optionId: '4', text: '小豆色' },
    ],
  },
  {
    quizId: '124',
    question:
      'サドが1920年代にイギリスであったと語っているストレスにより娘が父親を潜在意識に閉じ込めた事件、娘の名前は？',
    options: [
      { optionId: '0', text: 'ドリス' },
      { optionId: '1', text: 'エリス' },
      { optionId: '2', text: 'リリス' },
      { optionId: '3', text: 'アリス' },
      { optionId: '4', text: 'クリス' },
    ],
  },
  {
    quizId: '125',
    question:
      '高校野球地区予選編より問題です。\n意識に閉じ込められた状態から脱出するために考えた王子の作戦その①は？',
    options: [
      { optionId: '0', text: '犯人を特定し、そいつを退部へ追い込む' },
      { optionId: '1', text: '犯人が神聖視している甲子園を徹底的に破壊する' },
      { optionId: '2', text: '犯人の自我が耐えられなくなる程の悪行を行う' },
      { optionId: '3', text: '犯人に野球に集中してもらい、リラックスさせる' },
      { optionId: '4', text: 'このまま意識の中で山形の球場へ向かう' },
    ],
  },
  {
    quizId: '126',
    question:
      '如月高校野球部が甲子園地区予選決勝へ向かう途中で、野球部レギュラーの誰かの意識に入ってしまいましたが、誰かとは？',
    options: [
      { optionId: '0', text: '寺門' },
      { optionId: '1', text: '倉本' },
      { optionId: '2', text: '江尻' },
      { optionId: '3', text: '所沢' },
      { optionId: '4', text: '佐藤' },
    ],
  },
  {
    quizId: '127',
    question: 'ツインテールマーメイドのオークション、落札金額は？',
    options: [
      { optionId: '0', text: '3億' },
      { optionId: '1', text: '1億2000万' },
      { optionId: '2', text: '2億5000万' },
      { optionId: '3', text: '4億1000万' },
      { optionId: '4', text: '5億6000万' },
    ],
  },
  {
    quizId: '128',
    question: 'ツインテールマーメイドはどこの星の人魚？',
    options: [
      { optionId: '0', text: '惑星ホルン' },
      { optionId: '1', text: 'ペギ星' },
      { optionId: '2', text: 'ジャクリンS星' },
      { optionId: '3', text: 'カルバリ星' },
      { optionId: '4', text: 'エラル星' },
    ],
  },
  {
    quizId: '129',
    question:
      'ツインテールマーメイドは自然下では100年ほど生きるとされているが、単独飼育での寿命は長くてどのくらい？',
    options: [
      { optionId: '0', text: '4～5年' },
      { optionId: '1', text: '2年' },
      { optionId: '2', text: '10年' },
      { optionId: '3', text: '40年' },
      { optionId: '4', text: '50～60年' },
    ],
  },
  {
    quizId: '130',
    question:
      'ツインテールマーメイドは陸上での行動が可能なことから、他に何と呼ばれる？',
    options: [
      { optionId: '0', text: 'ウォーキング=フィッシュ' },
      { optionId: '1', text: 'ランド=マーメイド' },
      { optionId: '2', text: 'マーメイドフット' },
      { optionId: '3', text: 'グラウンド=マーメイド' },
      { optionId: '4', text: 'ヒューマンモドキ' },
    ],
  },
  {
    quizId: '131',
    question:
      'ツインテールマーメイドを落札し連れて行った先、階下へ下りるドアのパスワードは？',
    options: [
      { optionId: '0', text: '33306233' },
      { optionId: '1', text: '4384768' },
      { optionId: '2', text: '1354368' },
      { optionId: '3', text: '51786' },
      { optionId: '4', text: '7926432165' },
    ],
  },
  {
    quizId: '132',
    question:
      'ツインテールマーメイドの嘘を見破る能力は、擬態を得意とする天敵がいたために備わっているものですが、その天敵とは？',
    options: [
      { optionId: '0', text: 'フタマタモドキ' },
      { optionId: '1', text: 'クライブ' },
      { optionId: '2', text: 'カメレオンドーター' },
      { optionId: '3', text: 'ターナイマーメイド' },
      { optionId: '4', text: 'カンフレスト' },
    ],
  },
  {
    quizId: '133',
    question: 'カラーレンジャーの一人、横田のフルネームは？',
    options: [
      { optionId: '0', text: '横田国光' },
      { optionId: '1', text: '横田晃' },
      { optionId: '2', text: '横田月影' },
      { optionId: '3', text: '横田明久' },
      { optionId: '4', text: '横田京介' },
    ],
  },
  {
    quizId: '134',
    question: 'カラーレンジャーの一人、百池のフルネームは？',
    options: [
      { optionId: '0', text: '百池治' },
      { optionId: '1', text: '百池龍之介' },
      { optionId: '2', text: '百池達央' },
      { optionId: '3', text: '百池看二' },
      { optionId: '4', text: '百池聡' },
    ],
  },
  {
    quizId: '135',
    question: 'カラーレンジャーの一人、清水良樹の母親の名前は？',
    options: [
      { optionId: '0', text: '清水範子' },
      { optionId: '1', text: '清水沙織' },
      { optionId: '2', text: '清水香菜' },
      { optionId: '3', text: '清水絵梨' },
      { optionId: '4', text: '清水美千代' },
    ],
  },
  {
    quizId: '136',
    question: 'ドグラ星第2王子の名前は？',
    options: [
      { optionId: '0', text: 'モハン=キ=エト・ドグラ' },
      { optionId: '1', text: 'キリツ=ミ=エト・ドグラ' },
      { optionId: '2', text: 'ルル=キ=エル・ドグラ' },
      { optionId: '3', text: 'キソク=ミ=エル・ドグラ' },
      { optionId: '4', text: 'カマイ=ジ=エス・ドグラ' },
    ],
  },
  {
    quizId: '137',
    question: 'マグラ星第1王女の名前は？',
    options: [
      { optionId: '0', text: 'ルナ=ミ=マド・マグラ' },
      { optionId: '1', text: 'ムン=ミ=マド・マグラ' },
      { optionId: '2', text: 'チャルド=ミ=マド・マグラ' },
      { optionId: '3', text: 'ブラン=ミ=マド・マグラ' },
      { optionId: '4', text: 'ユエ=ミ=マド・マグラ' },
    ],
  },
  {
    quizId: '138',
    question:
      'バカ王子が議会にかけた\n「王位継承権を持つものは満20歳までに王妃候補を選定し結婚の儀を取り行うこと\nこの条件が満たされない場合、継承権は次順の王子に移行するものとする」\nという法案は、国民投票でどのくらいの支持を得たと王子は言っている？',
    options: [
      { optionId: '0', text: '96%以上' },
      { optionId: '1', text: '80%以上' },
      { optionId: '2', text: '84%以上' },
      { optionId: '3', text: '90%以上' },
      { optionId: '4', text: '1' },
    ],
  },
  {
    quizId: '139',
    question: 'バカ王子のフルネームは？',
    options: [
      { optionId: '0', text: 'バカ=キ=エル・ドグラ' },
      { optionId: '1', text: 'バカ=エト・ドグラバカ' },
      { optionId: '2', text: 'バカ=ミ=エト・ドグラ' },
      { optionId: '3', text: 'バカ=ミ=エル・ドグラ' },
      { optionId: '4', text: 'バカ=ジ=エス・ドグラ' },
    ],
  },
  {
    quizId: '140',
    question:
      '王家御用達の、一度はめると肉の一部となり生涯外せなくなる指輪は？',
    options: [
      { optionId: '0', text: 'バイオリング' },
      { optionId: '1', text: 'マリッジリング' },
      { optionId: '2', text: 'マグラリング' },
      { optionId: '3', text: 'ドグラリング' },
      { optionId: '4', text: 'マッドリング' },
    ],
  },
  {
    quizId: '141',
    question:
      'バカ王子・結婚編より問題です。\nバカ王子が筒井雪隆の部屋から盗聴器を探す際に、何を使ってダウジングをした？',
    options: [
      { optionId: '0', text: '自身の髪の毛' },
      { optionId: '1', text: '鎖' },
      { optionId: '2', text: '筒井雪隆の髪の毛' },
      { optionId: '3', text: '針金' },
      { optionId: '4', text: 'ネックレス' },
    ],
  },
  {
    quizId: '142',
    question:
      'バカ王子・結婚編より問題です。\nマグラ星第1王女からの手紙、暗号の解き方は？',
    options: [
      { optionId: '0', text: '誤字を塗りつぶすと本当の文章が浮かぶ' },
      { optionId: '1', text: '誤字だけ抜き出すと文章になる' },
      {
        optionId: '2',
        text: '誤字を切り抜き、紙を重ねた際に出てくる文字を抜き出すと文章になる',
      },
      {
        optionId: '3',
        text: '誤った偏と造りを組み合わせた文字で繋ぐと文章になる',
      },
      {
        optionId: '4',
        text: '文章中の誤字の文字位置と、50音順で対応する文字で文章になる',
      },
    ],
  },
  {
    quizId: '143',
    question:
      'バカ王子・結婚編より問題です。\nマグラ星第1王女からの手紙、指定場所は？',
    options: [
      { optionId: '0', text: '骨尾山山頂' },
      { optionId: '1', text: '高尾山ふもと' },
      { optionId: '2', text: '富士山山頂' },
      { optionId: '3', text: '空山のふもと' },
      { optionId: '4', text: '富神山山頂' },
    ],
  },
  {
    quizId: '144',
    question:
      'バカ王子・結婚編より問題です。\nマグラ星第1王女からの手紙、指定時間は？',
    options: [
      { optionId: '0', text: '満月の日の2時ちょうど' },
      { optionId: '1', text: '満月の日の12時ちょうど' },
      { optionId: '2', text: '新月の日の4時ちょうど' },
      { optionId: '3', text: '半月の日の1時ちょうど' },
      { optionId: '4', text: '半月の日の3時ちょうど' },
    ],
  },
  {
    quizId: '145',
    question: 'マグラ自由同盟が掲げているスローガンは？',
    options: [
      { optionId: '0', text: '無血革命でのマグラ星解放' },
      { optionId: '1', text: '無血革命でのドグラ星支配' },
      { optionId: '2', text: 'ドグラ星と対等の経済的進化' },
      { optionId: '3', text: '自由、平等、友愛' },
      { optionId: '4', text: '全てはマグラのために' },
    ],
  },
  {
    quizId: '146',
    question: 'バカ王子の娘の名前は？',
    options: [
      { optionId: '0', text: 'カナ' },
      { optionId: '1', text: 'バナ' },
      { optionId: '2', text: 'ルカ' },
      { optionId: '3', text: 'ミラ' },
      { optionId: '4', text: 'マミ' },
    ],
  },
  {
    quizId: '147',
    question: 'バカ王子達のハネムーン時に、誘拐を試みた金が目的の集団は？',
    options: [
      { optionId: '0', text: '革命商社クイーンツ' },
      { optionId: '1', text: '革命商社アルデオ' },
      { optionId: '2', text: '革命商社ジニール' },
      { optionId: '3', text: '革命商社ヒューツ' },
      { optionId: '4', text: '革命商社リトルリール' },
    ],
  },
  {
    quizId: '148',
    question:
      'バカ王子達を誘拐した際の、要求金額600,000オーパは日本円に換算するといくら？',
    options: [
      { optionId: '0', text: '40兆円' },
      { optionId: '1', text: '3000万円' },
      { optionId: '2', text: '8000万円' },
      { optionId: '3', text: '2兆円' },
      { optionId: '4', text: '10兆円' },
    ],
  },
  {
    quizId: '149',
    question: 'バカ王子達を誘拐した際の、制限時間1トロンは約何時間？',
    options: [
      { optionId: '0', text: '約3時間' },
      { optionId: '1', text: '約1時間' },
      { optionId: '2', text: '約5時間' },
      { optionId: '3', text: '約6時間' },
      { optionId: '4', text: '約10時間' },
    ],
  },
  {
    quizId: '150',
    question:
      'バカ王子が誘拐された際に、金の用意をするよう連絡しろと言われて、電話した相手は？',
    options: [
      { optionId: '0', text: '筒井雪隆' },
      { optionId: '1', text: 'クラフト' },
      { optionId: '2', text: '清水良樹' },
      { optionId: '3', text: 'サド' },
      { optionId: '4', text: 'ドグラ星の大臣' },
    ],
  },
  {
    quizId: '151',
    question:
      '北海道の環境保護指定区にいる、攻撃したり嫌がる人間に向かって喜んで集団で抱きついていく虫は？',
    options: [
      { optionId: '0', text: 'サゾドマ虫' },
      { optionId: '1', text: 'マゾサド虫' },
      { optionId: '2', text: 'サドマゾ虫' },
      { optionId: '3', text: 'マサドゾ虫' },
      { optionId: '4', text: 'ドマソザ虫' },
    ],
  },
  {
    quizId: '152',
    question:
      '最終話で筒井雪隆が見ていた看板に映っていたロタはどこの星の種族？',
    options: [
      { optionId: '0', text: 'ペギ星' },
      { optionId: '1', text: 'ジャクリンS星' },
      { optionId: '2', text: '惑星カルバリ' },
      { optionId: '3', text: 'エラル星' },
      { optionId: '4', text: '惑星ホルン' },
    ],
  },
  {
    quizId: '153',
    question: '次の内、惑星でないのは？',
    options: [
      { optionId: '0', text: 'マグラ' },
      { optionId: '1', text: '地球' },
      { optionId: '2', text: 'ドグラ' },
      { optionId: '3', text: 'カルバリ' },
      { optionId: '4', text: 'ホルン' },
    ],
  },
  {
    quizId: '154',
    question: 'レベルEのタイトルは何をもじって決められた？',
    options: [
      { optionId: '0', text: 'LEVEL4' },
      { optionId: '1', text: 'LEVEL1' },
      { optionId: '2', text: 'LEVEL2' },
      { optionId: '3', text: 'LEVEL3' },
      { optionId: '4', text: 'LEVEL5' },
    ],
  },
  {
    quizId: '155',
    question: 'レベルEのタイトル、Eは何の頭文字を勘違いして付けたもの？',
    options: [
      { optionId: '0', text: 'Alien' },
      { optionId: '1', text: 'Angel' },
      { optionId: '2', text: 'Abnormal' },
      { optionId: '3', text: 'Aborigine' },
      { optionId: '4', text: 'Apollo' },
    ],
  },
  {
    quizId: '156',
    question: '作中で一度も使われていない呪文は？',
    options: [
      { optionId: '0', text: 'バトルフラッシュ' },
      { optionId: '1', text: 'バトルポカリ' },
      { optionId: '2', text: 'バトルチンキ' },
      { optionId: '3', text: 'リルボム' },
      { optionId: '4', text: 'ゴールデンハンマー' },
    ],
  },
  {
    quizId: '157',
    question: '次の内、巻始めのキャラクター紹介に描かれていないのは？',
    options: [
      { optionId: '0', text: '清水良樹' },
      { optionId: '1', text: 'クラフト' },
      { optionId: '2', text: 'コリン' },
      { optionId: '3', text: 'サド' },
      { optionId: '4', text: '江戸川美歩' },
    ],
  },
];
